import { db } from "$lib/firebase";
import { query, type DocumentData, collection, orderBy, getDocs } from "firebase/firestore"; 


export function convertOrder(doc: DocumentData): TLOrder {
    const order: TLOrder = {
        uid : doc.uid ?? "",
        orderNumber: doc.orderNumber ?? -1,
        specialNeeds: doc.specialNeeds ?? "",
        phone: doc.phone ?? "",
        messageMode: doc.messageMode ?? "",
        pMethod: doc.pMethod ?? "",
        cart : doc.cart ?? [],
        cooked: doc.cooked ?? false,
        totalCharged : doc.totalCharged ?? 0,
        discount : doc.discount ?? 0,
        fee : doc.fee ?? 0,
        paid: doc.paid ?? false,
        created: doc.created ?? 0,
    };

    return order;
}

export async function getAllOrders(shopID: string): Promise<Array<TLOrder>> {
    const q = query(collection(db, "shops", shopID, "orders"), orderBy("created", "desc"));

    const querySnapshot = await getDocs(q);

    const orders: Array<TLOrder> = [];

    querySnapshot.forEach((doc) => {
        const dataObj = doc.data();

        const order = convertOrder(dataObj);
        orders.push(order);
    });

    return orders;
}


export function generatePaymentRecord(): PaymentRecord {
    const paymentRecord: PaymentRecord = {
        orderID: "",
        clientSecret: "",
        totalChargedCents: 0,
        discountCents: 0,
        feeCents: 0,
        error: "",
    }

    return paymentRecord;
}


export function convertPriceToCents(price: number): bigint {
    return BigInt(Math.round(price * 100));
}


export function convertPaymentRecord(data: DocumentData): PaymentRecord {
    const paymentRecord: PaymentRecord = {
        orderID: data.orderID ?? "",
        clientSecret: data.clientSecret ?? "",
        totalChargedCents: data.totalChargedCents ?? 0,
        discountCents: data.discountCents ?? 0,
        feeCents: data.feeCents ?? 0,
        error: data.error ?? "",
    }

    return paymentRecord;
}

export async function loadOrdersFilter(filterChosen: string, phone: string, valid: Boolean, cookedStatus: Boolean, paymentStatus: Boolean, shopID: string) : Promise<TLOrder[]>
{
    // console.log(filterChosen);

    let ordersFiltered = [];
    let orders = await getAllOrders(shopID);

    if(filterChosen === "Phone Number" && valid)
    {
        for(let orderF of orders)
        {
            if(orderF.phone === phone)
            {
                ordersFiltered.push(orderF);
            }
        }
    }

    if(filterChosen === "Cooked")
    {
        for(let orderF of orders)
        {
            if(orderF.cooked === cookedStatus)
            {
                ordersFiltered.push(orderF);
            }
        }
    }

    if(filterChosen === "Paid Status")
    {
        for(let orderF of orders)
        {
            if(orderF.paid === paymentStatus)
            {
                ordersFiltered.push(orderF);
            }
        }
    }

    ordersFiltered = ordersFiltered;
    return ordersFiltered;
}


export function generateOrder() {
    const order: TLOrder = convertOrder({});

    return order;
}
